import styled from 'styled-components';

export const StyledSearch = styled.div`
  padding: 0 20px;
  margin-bottom: 20px;

  & h1 {
    font-size: ${({ theme }) => theme.fontSizes.h1.m};
    font-weight: ${({ theme }) => theme.fontWeights[6]};
    padding: 20px 0;

    &:last-of-type {
      margin-bottom: 20px;
      border-bottom: 1px solid ${({ theme }) => theme.colors.gray};
    }
  }

  & > section {
    font-size: ${({ theme }) => theme.fontSizes.m};
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray};
    margin-bottom: 20px;

    @media only screen and (max-width: ${({ theme }) => theme.breakpoints[3]}) {
      font-size: ${({ theme }) => theme.fontSizes.s};
    }

    @media only screen and (max-width: ${({ theme }) => theme.breakpoints[4]}) {
      font-size: ${({ theme }) => theme.fontSizes.m};
    }

    & article {
      flex-basis: 25%;

      @media only screen and (max-width: ${({ theme }) => theme.breakpoints[0]}) {
        flex-basis: 33.333333%;
      }

      @media only screen and (max-width: ${({ theme }) => theme.breakpoints[2]}) {
        flex-basis: 50%;
      }

      @media only screen and (max-width: ${({ theme }) => theme.breakpoints[4]}) {
        flex-basis: 100%;
      }
    }
  }

  .pagination-wrapper {
    text-align: center;
    & .pagination-link {
      text-decoration: none;
      font-size: ${({ theme }) => theme.fontSizes.xl};
      font-weight: ${({ theme }) => theme.fontWeights[4]};
      display: inline-block;
      margin: 0 auto;
      margin-bottom: 20px;
      color: ${({ theme }) => theme.colors.tycoonMain};
  
      &:hover {
        color: ${({ theme }) => theme.colors.black};
      }
    }
  }
`;
